import React from "react";
import { SvgProps } from "./Form";

export const SmallPriceLedger = (props: SvgProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.5 6H15.5"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.5 10H8.5"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.5 14H9.5"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <mask
      id="mask0_6312_333"
      maskUnits="userSpaceOnUse"
      x="9"
      y="7"
      width="9"
      height="9"
    >
      <path d="M17.5 7.5H9.5V15.5H17.5V7.5Z" fill="white" />
    </mask>
    <g mask="url(#mask0_6312_333)">
      <path
        d="M13.5 8.25V9"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.5 14V14.75"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.25 10.25C15.25 10.0859 15.2177 9.9233 15.1548 9.77165C15.092 9.61999 15 9.48219 14.8839 9.36612C14.7678 9.25004 14.63 9.15797 14.4784 9.09515C14.3267 9.03233 14.1642 9 14 9H13C12.6685 9 12.3505 9.1317 12.1161 9.36612C11.8817 9.60054 11.75 9.91848 11.75 10.25C11.75 10.5815 11.8817 10.8995 12.1161 11.1339C12.3505 11.3683 12.6685 11.5 13 11.5H14.25C14.5815 11.5 14.8995 11.6317 15.1339 11.8661C15.3683 12.1005 15.5 12.4185 15.5 12.75C15.5 13.0815 15.3683 13.3995 15.1339 13.6339C14.8995 13.8683 14.5815 14 14.25 14H12.75C12.4185 14 12.1005 13.8683 11.8661 13.6339C11.6317 13.3995 11.5 13.0815 11.5 12.75"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
);
